export default __webpack_public_path__ + "static/media/smirk.030053cd.png";